// extracted by css-extract-rspack-plugin
export default {"modalContainer":"qiAnle","active":"k3loNL","maskTop":"Gp7U3b","maskBottom":"ZNyuvo","shadow":"S36Wzs","handLeft":"FXFkXJ","handRight":"Ne7wVr","handAnimation":"ylth8f"};